<template>
  <div class="moble_body">

    <div class="shouji">
      <div class="tupian"><img src="/bangding.png"></div>
    </div>

    <div class="beij"></div>

    <div class="shoujihaoma">
      <div class="haoma">手机号码</div>
      <div class="shuru"><van-cell-group><van-field v-model="value" placeholder="请输入手机号码" /></van-cell-group></div>
      <div class="yanzheng" @click="pushdata()" >获取验证码
        <div class="miao"><van-count-down v-if="ivs" :time="time" format="ss"/></div>
      </div>
    </div>

    <div class="yanzhengma">
      <div class="ma">验证码</div>
      <div class="shuruma"><van-cell-group><van-field v-model="value1" placeholder="请输入验证码" /></van-cell-group></div>
    </div>

    <div><van-button @click="push" type="primary" block>保存</van-button></div>


  </div>
</template>

<script>
    import {Toast} from 'vant';
    export default {
        name: "Mobile",
        data() {
            return {
                value: '',
                time:  60 * 1000,
                value1:'',
                ivs:false,
            }
        },
        created() {

        },
        methods:{
            pushdata() {
                this.ivs=true
                this.myrequest({
                    url:'/client/getmsgsend.action',
                    types:'post',
                    data:{
                        // token:this.$store.state.token
                        username:this.value,
                    },
                    succ: (res) => {

                    },
                    errs: (msg) => {

                    }
                })
            },
            push() {
                this.myrequest({
                    url:'/client/addbindinguserinfo.action',
                    types:'post',
                    data:{
                        // token:this.$store.state.token
                        types:1,
                        mobile:this.value,
                        yzm:this.value1
                    },
                    succ: (res) => {
                        Toast.success('绑定成功');
                        this.$router.go(-1)
                    },
                    errs: (msg) => {

                    }
                })
            },
        }
    }
</script>

<style scoped lang="stylus">
  .moble_body {
    width 100%;

    >>>.van-button--block{
      width 80%;
      margin 10px auto;
      border-radius 10px;
    }
    >>>.van-cell{
      width 100%;
    }
    .beij {

      background-color #fafafa;
      width 100%;
      height 10px;
      margin-top 20px;
    }

    .shouji {
      width 100%;
      .tupian{
        width 100%;
        height 150px;
        img{
          width 100%;
        }
      }
    }
    .yanzhengma{
      width 95%;
      margin auto;
      height 45px;
      border-bottom 1px solid #f5f5f5;
      line-height 45px;
      display flex;
      flex-direction: row;
      align-items: center;
      .ma{
        color #333;
        font-weight 500;
        font-size 14px;
        width 20%;
        text-align center
      }
      .shuruma{
        >>>.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
          border 0px;
        }
      }
    }
    .shoujihaoma{
      width 95%;
      margin auto
      display flex;
      flex-direction: row;
      align-items: center;
      border-bottom 1px solid #f5f5f5;
      position relative
      /*border-bottom 1px solid #000;*/
      height 45px
      >>>.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
        border 0px;
      }
      .haoma{
        width 20%
        text-align center;
        color #333;
        font-weight 500;
        font-size 14px;
      }
      .yanzheng{
        width 20%;
        background-color #0AC1BA;
        color #fff;
        height 30px;
        border-radius 5px;
        font-size 14px;
        line-height 30px;
        display flex;
        .miao{
          position absolute;
          right 0px;
          top 12px;
          >>>.van-count-down{
            color red
          }
        }
      }
      .shuru{
        width 55%;


      }

    }

  }


</style>



// WEBPACK FOOTER //
// src/components/wode/Mobile.vue